import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { Home, Link2Off } from 'lucide-react';
import { api } from '../../lib/api.js';
import { formatDateTime } from '../../lib/format.js';
import { useSession } from '../../app/session.jsx';
import { useDocumentTitle } from '../../app/hooks.js';
import { Button, EmptyState, Spinner } from '../../components/ui.jsx';
import { AuthLayout } from './AuthPages.jsx';

export function InvitePage() {
  useDocumentTitle('Convite');
  const { token } = useParams();
  const { user, loading, refresh } = useSession();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const preview = useQuery({
    queryKey: ['invite', token],
    queryFn: () => api(`/api/invites/${encodeURIComponent(token)}`),
    retry: false,
  });

  const accept = async () => {
    setBusy(true);
    setError(null);
    try {
      await api('/api/invites/accept', { method: 'POST', body: { token } });
      await refresh();
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const back = encodeURIComponent(`/convite/${token}`);
  return (
    <AuthLayout title="Convite para um lar">
      {preview.isPending || loading ? (
        <div className="state">
          <Spinner />
        </div>
      ) : preview.isError ? (
        <EmptyState
          icon={Link2Off}
          title="Convite indisponível"
          action={
            <Link className="btn" to="/">
              Ir para o início
            </Link>
          }
        >
          {preview.error.message}
        </EmptyState>
      ) : (
        <div className="stack" style={{ gap: 'var(--s-4)' }}>
          <EmptyState icon={Home} title={preview.data.householdName}>
            {preview.data.invitedBy ? `${preview.data.invitedBy} convidou você` : 'Você foi convidado(a)'}{' '}
            para participar
            {preview.data.role === 'admin' ? ' como administrador(a)' : ''}. Convite válido até{' '}
            {formatDateTime(preview.data.expiresAt)}.
          </EmptyState>
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          {user ? (
            <Button variant="primary" block loading={busy} onClick={accept}>
              Entrar no lar como {user.name}
            </Button>
          ) : (
            <>
              <Link className="btn btn-primary btn-block" to={`/cadastrar?volta=${back}`}>
                Criar conta e aceitar
              </Link>
              <Link className="btn btn-block" to={`/entrar?volta=${back}`}>
                Já tenho conta
              </Link>
            </>
          )}
        </div>
      )}
    </AuthLayout>
  );
}
